import {KTCard} from '../../../_metronic/helpers'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {ProfileHeader} from './components/ProfileHeader'

const userProfileBreadcrumbs: Array<PageLink> = [
  {
    title: 'Gestão de Perfil',
    path: '/user-profile',
    isSeparator: false,
    isActive: false,
  },
]

const UserProfilePage = () => {
  return (
    <>
      <PageTitle breadcrumbs={userProfileBreadcrumbs}>Perfil do Usuário</PageTitle>
      <ProfileHeader />
    </>
  )
}

export default UserProfilePage
